jQuery(function($) { // jQuery init

	// Sidebar Collapers
	var collapser = $('.collapsible-chapters > li > a.collapser');

	collapser.on('click', function(e) {

		var $this = $(this);

		var parent = $(this).parent()

		// Check to see if the group is open/active.
		if ( $(parent).hasClass('active') ) {

			// Does the regular link action.
		
		// if has subsections
		} else if ($this.next('ul').find('li').length) {


			$(parent).toggleClass('active');
			$(parent).find('> ul').slideToggle('fast');

			e.preventDefault();
			return false; 

		} ;

	});


	// Content
	var chCollapser = $('.ch-topic-item > .chtpc-header');

	chCollapser.on('click', function() {
		var $this = $(this);

		chCollapser.next('.chtpc-content').slideUp('fast', function() {
			chCollapser.parent('.ch-topic-item').removeClass('active');		});

		if ( !$this.parent('.ch-topic-item').hasClass('active') && !$this.next('.chtpc-content').is(':visible') ) {
			$this.parent('.ch-topic-item').addClass('active')
			 	.find('> .chtpc-content').slideDown('fast');
		}

		// jquery.nicescroll init
		$('.ch-topics').getNiceScroll().resize();

	});


	// navigate sub-section
	// var subsection = collapser.next('ul').find('> li > a');
	var subsection = $('.collapsible-chapters > li > ul > li > a');

	subsection.on('click', function(e) {
		e.preventDefault();

		var $this = $(this);
		pattern = /^((http|https|ftp):\/\/)/;

		var currentUrl = location.href.split('#')[0];
		var thisUrl = ( !pattern.test($this.data('href')) ) ? location.protocol + $this.data('href') : $this.data('href');

		if ( currentUrl == thisUrl ) {
			chapterScroll( $this.attr('href') );
		} else {
			location.href = $this.attr('href');
		}
	});

	var screenX = window.screen.width;
	$(window).resize(function() {
		screenX = window.screen.width;
	})

	function chapterScroll( $elemId ) {

		if( !$($elemId).length ) {
			return false;
		}
		
		var id = $elemId ;

		$('html, body').animate({
	        scrollTop: $(id).offset().top - 50
	    }, 600);

		$(id).css('background','#11a399');
		setTimeout(function() {
			$(id).css('background', 'transparent');
		}, 3000);

	    return;
	}

	// Anchor from url hash
	var currentHash = window.location.hash;
	if ( currentHash ) {
		chapterScroll( currentHash );
	} else if ( $('.single-handbook').length > 0 ) {
		$('html, body').animate({
			scrollTop: $('.ch-topics').offset().top - 100
		});
	}

	// In-page reference
	var fnDelay;
	var footnote = $('.ch-topics .footnote, .ch-topics a');
	var refFootnote = $('.ref-footnote');

	
	function displayFootNote( $this, e, idBack = null ){

		var href = $this.attr('href');

		if ( href == undefined ) {
			href = $(this).parent().attr('href');
		}
		

		var parts = href.split('/');
		var lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
		var id = lastSegment ;
		var chapter = parts[4]

		$(id).fadeToggle();
 
		$('.references-container > div').removeClass('first');
		$('.references-container > div:visible:first').addClass('first');

		if ( idBack ) {
			$(id).closest('div').find('.close').attr('data-back', idBack);
		}

		$('html, body').animate({
	        scrollTop: $(id).offset().top  - ( $('.chtpc-content').offset().top - $(id).outerHeight() ) 
	    }, 600);

		e.preventDefault();

	}
	
	footnote.on("click" , function(e) {
		e.preventDefault();
		var $this = $(this);
		var uniqId = 'ref-' + Date.now();

		if ( $this.find('> sup').length > 0 ) {
			$this.attr('id', uniqId);
			displayFootNote($this, e, uniqId)
		} else {
			manageAnchorLink( $this.attr('href') );
		}
		
	});

	$(document).on("click",".references-container .close ", function() {
		var $this = $(this);
		var id = '#' + $this.data('back');
		$this.parent().fadeOut();
		$('html, body').animate({
	        scrollTop: $(id).offset().top  - 100
	    }, 600);
	});
	

	function footNoteToggle() {
		fnDelay = setTimeout(function() {
			refFootnote.fadeOut(function() {
				refFootnote.find('ul > li').hide();
			});
		}, 8000);
	}

	$('#closeTopicRef').on('click', function(e) {
		e.preventDefault();
		$(this).parent().fadeOut();
	});

	refFootnote.on('mouseover', function() {
		clearTimeout( fnDelay );
	}).on('mouseout', function() {
		footNoteToggle();
	});

	var refContent = $('.return-action > a');
	refContent.on('click', function(e) {
		e.preventDefault();
		var $this = $(this);
		if ( $('.ch-topics').find($this.attr('href')).length > 0 ) {
			
			var $return = ( $($this.attr('href')).has('sup').length ) ? $this.attr('href') : $($this.attr('href')).prev('a');
			chapterScroll( $return );
			RefHightlight( $this.attr('href') );
		}

		return;
	});

	function RefHightlight( selector, returnId = null ) {
		$(selector).css('background','#11a399')
			.find('> .return-action > a').attr( 'href', '#'+returnId );

		setTimeout(function() {
			$(selector).css('background', 'transparent');
		}, 3000);

		return;
	}

	var chapterIntroCollpase = $('.tax-chapter .content-fold .content-header');
	chapterIntroCollpase.on('click', function() {
		var $this = $(this);

		$this.next('.content-description').slideToggle('fast');
		$this.closest('.content-fold').toggleClass('active');

	});

	function manageAnchorLink( url ) {
		var thisUrl = parseURL( url );
		if ( thisUrl.host == window.location.host ) {
			if ( thisUrl.pathname != window.location.pathname ) {
				location.href = url;
			} else {
				// will look for target inside the content
				chapterScroll( thisUrl.hash );
			}
			return;
		} else {
			window.open(url, '_blank');
		}
	}

	function parseURL( url ) {
	    var parser = document.createElement('a'),
	        searchObject = {},
	        queries, split, i;
	    // Let the browser do the work
	    parser.href = url;
	    // Convert query string to object
	    queries = parser.search.replace(/^\?/, '').split('&');
	    for( i = 0; i < queries.length; i++ ) {
	        split = queries[i].split('=');
	        searchObject[split[0]] = split[1];
	    }
	    return {
	        protocol: parser.protocol,
	        host: parser.host,
	        hostname: parser.hostname,
	        port: parser.port,
	        pathname: parser.pathname,
	        search: parser.search,
	        searchObject: searchObject,
	        hash: parser.hash
	    };
	}

});
